import {Divider, Grid, ListItem, ListItemIcon, ListItemText, Typography, withStyles} from '@material-ui/core';
import {Brightness1} from '@material-ui/icons';
import React from 'react';
import PropTypes from 'prop-types';
import CreditChartV2 from 'components/credit-chart-v2';
import PercentageBarV2 from 'components/percentage-bar-v2';
import {formatMoney, customCurrencyFormat} from 'core/utils';

const AccruedExpenditure = ({creditSummary, transactionsByCategory}) => {
    const sortedData = [...transactionsByCategory].sort((a, b) => (a.amount < b.amount) ? 1 : -1);
    const colors = [
        '#29CCFF',
        '#4BB543',
        '#E99518',
        '#D00404',
        '#FFD100',
        '#D0CBBD',
        '#59c9b0',
        '#FF8888',
        '#636363',
        '#FF9FDE',
        '#A29A9C',
    ];
    const transactionsData = sortedData.reduce((acc, transaction, index) => {
        if (transaction.category.name !== 'Disponible') {
            acc.push({
                amount: transaction.amount,
                currency: transaction.amountCurrency,
                color: colors[index],
                name: transaction.category.name,
            });
        }
        return acc;
    }, []);
    const calculatePercentages = (data) => {
        if (creditSummary.total === 0) return 0;
        return (data.amount / creditSummary.total * 100).toFixed(0);
    };

    return (
        <Root container spacing={4}>
            <Grid item xs={12} md={6}>
                <CardsContainer container spacing={2} justify='space-between'>
                    <Grid item>
                        <Grid container spacing={2} direction='column' justify='space-between' style={{height: '100%'}}>
                            <Grid item>
                                <Typography variant='h2'>Crédito Total</Typography>
                                <Typography variant='h3' style={{fontWeight: 'bold'}}>
                                    {formatMoney(creditSummary, 'total')}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <StyledDivider />
                                <Typography variant='h3'>Consumido</Typography>
                                <Typography variant='h3' style={{fontWeight: 'bold'}}>
                                    {`(${creditSummary.consumedPercentage}%) ${formatMoney(creditSummary, 'consumed')}`}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        {creditSummary && (
                            <CreditChartV2 creditSummary={creditSummary} />
                        )}
                    </Grid>
                </CardsContainer>
            </Grid>
            <Grid item xs={12} md={6}>
                <CardsContainer container spacing={2}>
                    <Grid item>
                        <Typography variant='h2'>Crédito Consumido</Typography>
                        <Typography variant='h3' style={{fontWeight: 'bold'}}>
                            {formatMoney(creditSummary, 'consumed')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <PercentageBarV2
                            transactionsData={transactionsData}
                        />
                    </Grid>
                    <Grid item>
                        {transactionsData.map((data, index) =>
                            (
                                <ListItem>
                                    <ListItemIcon style={{minWidth: '20px'}}>
                                        <Brightness1 fontSize='small' style={{color: data.color}} />
                                    </ListItemIcon>
                                    <ListItemText disableTypography style={{marginBottom: '0px', marginTop: '0px'}}>
                                        <Typography component='span' variant='h4' style={{fontWeight: 'bold'}}>
                                            {data.name}
                                            <Typography variant='h4' component='span'>
                                                {` ${customCurrencyFormat(data, 'amount', data.currency)} (${calculatePercentages(data)}%)`}
                                            </Typography>
                                        </Typography>
                                    </ListItemText>
                                </ListItem>
                            ))
                        }
                    </Grid>
                </CardsContainer>
            </Grid>
        </Root>
    );
};

AccruedExpenditure.propTypes = {
    creditSummary: PropTypes.object.isRequired,
    transactionsByCategory: PropTypes.array.isRequired,
};

export default AccruedExpenditure;

const Root = withStyles((theme) => ({
    root: {
        marginTop: theme.spacing(4),
    },
}))(Grid);

const CardsContainer = withStyles((theme) => ({
    root: {
        background: '#FFFFFF',
        borderRadius: '10px',
        height: '100%',
        padding: '20px',
        border: '1px #D9D9D9 solid',
    },

}))(Grid);

const StyledDivider = withStyles((theme) => ({
    root: {
        width: '55%',
        height: theme.spacing(1),
        borderRadius: '50px',
        marginBottom: '10px',
        display: 'none',
    },
}))(Divider);




// WEBPACK FOOTER //
// ./views/home/supervisor-home/accrued-expenditure/index.js